/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Select } from '@atoms';
import { NARROW_COL } from '@constants';
import { useAudiences } from '@api/hooks';

import Form from '../Form';

const AudiencesField = (props) => {
  const { audiences, isFetching } = useAudiences();

  return (
    <Form.Item wrapperCol={NARROW_COL} {...props}>
      <Select.Entities
        loading={isFetching}
        placeholder="- Choose an audience -"
        entities={audiences}
        formatLabel={({ name }) => name}
      />
    </Form.Item>
  );
};

export default AudiencesField;
